export default __webpack_public_path__ + "static/malinka-d3dc484cb86c9e4851b5ba7a85995237.jpg";